













































































































































































import { LoginVue } from "fs-pb-vue2/vueModels/auth/LoginVue";
import { Component, Watch } from "vue-property-decorator";
import BackLink from "@/components/app/BackLink.vue";
import EbsStart from "@/components/ebs/EbsStart.vue";
import VerifyBox from "@/components/app/VerifyBox.vue";

@Component({
  components: { BackLink, EbsStart, VerifyBox }
})
export default class Login extends LoginVue {

  ebsDialog: boolean = false;

  @Watch('loginValue', { immediate: true })
  loginChanged(val: string): void {
    if (val && val.length)
      this.model.Login = val.replaceAll('(', '').replaceAll(')', '').replaceAll(' ', '').replaceAll('-', '');
  }

  loginValue: string = '';
    
  async mounted() {
    await this.init();
  }

  showEbsDialog(): void {
    this.ebsDialog = true;
  }
  hideEbsDialog(): void {
    this.ebsDialog = false;
  }

  validateForm(): void {
    // Проверяем форму на валидность
    (this.$refs.form as any).validate();
  }

  resetFormValidation(): void {
    // Сбрасываем реззультаты валидации
    (this.$refs.form as any).resetValidation();
  }
}
